<div class="swiper myAdsSwiper">
    <div class="swiper-wrapper">
        <div class="swiper-slide" style="height: 265px;" *ngFor="let ads of businessAds" >
            <a  title="{{ads.businessName}}" class="category-carousel-item fl-wrap full-height"
            routerLinkActive="active" [routerLink]="['/business-details', ads.businessName | businessSlug]" target="_blank">
            <div class="listing-item-grid">
                <div class="bg" [ngStyle]="{'background-image': ' url('+serverImgUrl +'adsImages/'+ ads.adsImageURL+')'}"></div>
                <div class="d-gr-sec"></div>
                <div class="listing-counter color2-bg">
                    <span><i class="fas fa-map-marker-alt"></i> {{ads.businessCity}} | {{ads.adsDistrict}}, </span>{{ads.adsState}} | {{ads.adsCountry}}
                    <a *ngIf="ads.facebookURL" [href]="ads.facebookURL" class="ms-1 text-white" target="_blank" rel="noopener" title="Facebook"><i class="fab fa-facebook"></i></a>
                    <a *ngIf="ads.twitterURL" [href]="ads.twitterURL" class="ms-1 text-white" target="_blank" rel="noopener" title="Twitter"><i class="fab fa-twitter"></i></a>
                    <a *ngIf="ads.instagramURL" [href]="ads.instagramURL" class="ms-1 text-white" target="_blank" rel="noopener" title="Instagram"><i class="fab fa-instagram"></i></a>
                </div>
                <div class="listing-item-grid_title">
                    <h3><a routerLinkActive="active" [routerLink]="['/business-details', ads.businessName | businessSlug]" title="{{ads.adsTitle}}"> {{ads.adsTitle | shorten: 50: '...'}} </a></h3>
                    <p class="mb-0 mp-0">{{ads.businessName | shorten: 30: '...'}}</p>
                </div>
            </div>
            </a>
        </div>
    </div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
</div>

<div class="alert alert-danger p-2 mb-0" *ngIf="noAds"> The campaign or ad set does not have a published.</div>